import { Step, StepType } from "./step";

export class FormData {
    private steps: Step[] = [];

    /**
     * Add step to steps array
     * 
     * @param {StepType} step Step to add
     */
    addStep(step: StepType): void {
        this.steps.push(step);
    }

    /**
     * Get steps
     * 
     * @returns {Step[]}
     */
    getSteps(): Step[] {
        return this.steps;
    }
}
